if (!customElements.get("pickup-availability")) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if (!this.hasAttribute("available")) return;

      this.errorHtml = this.querySelector("template").content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);
      
      // Si el drawer ya existe, cargar el contenido personalizado
      setTimeout(() => {
        const existingDrawer = document.querySelector("#Drawer-Pickup-Availability");
        if (existingDrawer) {
          this.loadCustomContent();
        }
      }, 100);
    }

    fetchAvailability(variantId) {
      let rootUrl = this.dataset.baseUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");
          this.renderPreview(sectionInnerHTML);
        })
        .catch((e) => {
          const button = this.querySelector("button");
          if (button) button.removeEventListener("click", this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = "";
      this.appendChild(this.errorHtml);

      this.querySelector("button").addEventListener("click", this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector("#Drawer-Pickup-Availability");
      if (drawer) drawer.remove();
      if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
        this.innerHTML = "";
        this.removeAttribute("available");
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector("pickup-availability-preview").outerHTML;
      this.setAttribute("available", "");

      document.body.appendChild(sectionInnerHTML.querySelector("#Drawer-Pickup-Availability"));

      // Cargar contenido personalizado en el drawer
      this.loadCustomContent();

      const button = this.querySelector("button");

      if (button) {
        button.addEventListener("click", (e) => {
          document.querySelector("#Drawer-Pickup-Availability").openDrawer();
        });
      }
    }

    loadCustomContent() {
      const drawer = document.querySelector("#Drawer-Pickup-Availability");
      if (!drawer) return;

      let pickupData = null;
      try {
        const dataAttr = this.dataset.pickupCustom;
        if (dataAttr) {
          pickupData = JSON.parse(dataAttr);
        }
      } catch (e) {
        console.error("Error parsing pickup data:", e);
        return;
      }

      if (!pickupData) return;

      const imageContainer = drawer.querySelector("[data-pickup-image-container]");
      const textContainer = drawer.querySelector("[data-pickup-text-container]");

      // Cargar imagen si existe
      if (imageContainer) {
        if (pickupData.image && pickupData.image !== "") {
          imageContainer.innerHTML = `<img src="${pickupData.image}" alt="Ubicación" style="width: 100%; height: auto; border-radius: 8px;">`;
        } else {
          imageContainer.innerHTML = "";
        }
      }

      // Cargar texto si existe
      if (textContainer) {
        if (pickupData.text && pickupData.text !== "") {
          textContainer.innerHTML = pickupData.text;
        } else {
          textContainer.innerHTML = "";
        }
      }
    }
  }

  customElements.define("pickup-availability", PickupAvailability);
}

if (!customElements.get("pickup-availability-drawer")) {
  class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();

      this.drawerWapper = this.querySelector(".m-drawer__wrapper");
      this.drawerContent = this.querySelector(".m-drawer__content");
      this.drawerClose = this.querySelector(".m-drawer__close");

      this.drawerClose.addEventListener("click", (e) => {
        e.preventDefault();
        this.closeDrawer();
      });

      document.body.addEventListener("click", (e) => {
        if (e.target.classList.contains("m-drawer__wrapper")) this.closeDrawer();
      });
    }

    openDrawer() {
      // Cargar contenido personalizado antes de abrir
      const pickupElement = document.querySelector("pickup-availability");
      if (pickupElement && typeof pickupElement.loadCustomContent === 'function') {
        pickupElement.loadCustomContent();
      }

      if (window.innerWidth < 770) {
        document.documentElement.classList.add("prevent-scroll");
        this.drawerWapper.classList.add("mobile");
      }
      this.drawerWapper.classList.remove("m:hidden");
      requestAnimationFrame(() => {
        this.drawerWapper.style.setProperty("--m-bg-opacity", "0.5");
        this.drawerContent.style.setProperty("--m-translate-x", "0");
        // this.drawerContent.classList.remove('translate-x-full')
      });
    }

    closeDrawer() {
      this.drawerWapper.style.setProperty("--m-bg-opacity", "0");
      this.drawerContent.style.setProperty("--m-translate-x", "100%");
      // this.drawerContent?.classList.add('translate-x-full')
      setTimeout(() => {
        this.drawerWapper.classList.add("m:hidden");
        this.drawerWapper.classList.remove("mobile");
        document.documentElement.classList.remove("prevent-scroll");
      }, 300);
    }
  }

  customElements.define("pickup-availability-drawer", PickupAvailabilityDrawer);
}

// Inicializar contenido personalizado cuando el DOM esté listo
document.addEventListener("DOMContentLoaded", () => {
  const pickupElement = document.querySelector("pickup-availability");
  if (pickupElement && typeof pickupElement.loadCustomContent === 'function') {
    setTimeout(() => {
      pickupElement.loadCustomContent();
    }, 500);
  }
});
